// @flow

import dayjs from 'dayjs';
import I18n from '@insolus/i18n';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import 'dayjs/locale/fr';
import 'dayjs/locale/de';

export default () => {
    dayjs.locale(I18n.language);
    dayjs.extend(customParseFormat);
};
